import tabooThumb from '../../assets/video-thumbnails/tabboThumbnail.png'
import TMBIThumb from '../../assets/video-thumbnails/TMBI.png'
import paradise from '../../assets/video-thumbnails/paradiseThumb.webp'
import howSad from '../../assets/video-thumbnails/HowSad.webp'
import faded from '../../assets/video-thumbnails/faded.png'
import oohYeah from '../../assets/video-thumbnails/oohYeah.png'
import found from '../../assets/video-thumbnails/found.webp'
import cool from '../../assets/video-thumbnails/coolMeDown.jpg'
import airplane from '../../assets/video-thumbnails/airplane.webp'
import mars from '../../assets/video-thumbnails/mars.png'
import ydlm from '../../assets/video-thumbnails/ydlm.webp'
import loveAnother from '../../assets/video-thumbnails/loveAnother.webp'

const videosData = [
  {
    title: 'Janette King - Taboo (Official Video)',
    thumbnail: tabooThumb,
    url: 'https://youtu.be/kq55JnM-_Ks',
    embedUrl: 'https://www.youtube.com/embed/kq55JnM-_Ks?si=2TNU4WPvvs4s1X_v',
  },
  {
    title: 'Janette King - This Might Be It (Official Video)',
    thumbnail: TMBIThumb,
    url: 'https://youtu.be/m99bW0duI6M',
    embedUrl: 'https://www.youtube.com/embed/m99bW0duI6M?si=Zbdc0521Qi-0p6nQ',
  },
  {
    title: 'Janette King - Paradise',
    thumbnail: paradise,
    url: 'https://youtu.be/bNQLo7BjNOU',
    embedUrl: 'https://www.youtube.com/embed/bNQLo7BjNOU?si=ns87_iuQ4fkrLH22',
  },
  {
    title: 'Janette King - How Sad (Official Video)',
    thumbnail: howSad,
    url: 'https://youtu.be/KTsWtk78Y8w',
    embedUrl: 'https://www.youtube.com/embed/KTsWtk78Y8w?si=iEOCZvKXRk8GnHnJ',
  },
  {
    title: 'Janette King - Faded (Official Video) Prod. Jordan Esau',
    thumbnail: faded,
    url: 'https://youtu.be/hxA21pVNOMM',
    embedUrl: 'https://www.youtube.com/embed/hxA21pVNOMM?si=PQTrr5rI2AjzuQNu',
  },
  {
    title: 'Janette King - Ooh Yeah (Official Video) Prod. GRAY',
    thumbnail: oohYeah,
    url: 'https://youtu.be/0o2VhSMDHuE',
    embedUrl: 'https://www.youtube.com/embed/0o2VhSMDHuE?si=F5AXJFOvUlIBmhe5',
  },
  {
    title: 'Janette King - Found A Way (Official Video) Prod. Jordan Esau',
    thumbnail: found,
    url: 'https://youtu.be/5nQPRO0sYJw',
    embedUrl: 'https://www.youtube.com/embed/5nQPRO0sYJw?si=FKiTdSzvqTQqsE0q',
  },
  {
    title: 'Janette King - Cool Me Down (feat. DijahSB) prod. Jonny Tobin',
    thumbnail: cool,
    url: 'https://youtu.be/7GcknHQcT4E',
    embedUrl: 'https://www.youtube.com/embed/7GcknHQcT4E?si=tUy1KGRfYDP0KRDw',
  },
  {
    title: 'Janette King - Airplane (Official Video) Prod. Jordan Esau',
    thumbnail: airplane,
    url: 'https://youtu.be/6brJ5C3-wAE',
    embedUrl: 'https://www.youtube.com/embed/6brJ5C3-wAE?si=iiXgwYYbUgNsgHU6',
  },
  {
    title: 'Janette King - Mars (Prod. Jonny Tobin)',
    thumbnail: mars,
    url: 'https://youtu.be/6AXRaIOAlxI',
    embedUrl: 'https://www.youtube.com/embed/6AXRaIOAlxI?si=Fwf10sAkt8sSXZsO',
  },
  {
    title:
      "Janette King - You Don't Love Me (Official Video) Prod. Jonny Tobin",
    thumbnail: ydlm,
    url: 'https://youtu.be/WePRzklNc1c',
    embedUrl: 'https://www.youtube.com/embed/WePRzklNc1c?si=GuYQa_cUa4Phoiza',
  },
  {
    title:
      'Janette King - Love Another (Produced by BrotherNature) (Official Video)',
    thumbnail: loveAnother,
    url: 'https://youtu.be/NspzUv6CwAg',
    embedUrl: 'https://www.youtube.com/embed/NspzUv6CwAg?si=rwjVS6mmpnsNyIgk',
  },
]

export default videosData
